
    // @ts-ignore
    module.exports = __webpack_public_path__ + "audioplayer.worklet.js";
    